module.exports = __webpack_public_path__ + "img/icon_setting.992148ce.svg";